import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { EpcotConfig, MyBetsConfig, SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { RedirectHelperService } from '../../../navigation-core/redirect-helper.service';
import { MarketUrlParam } from '../../../navigation-core/url-helper.service';
import { MyBetsUtilService } from '../../services/my-bets-util.service';

@Component({
    selector: 'ms-my-bets-betbuilder-card',
    templateUrl: 'my-bets-betbuilder-card.html',
    styleUrl: 'my-bets-betbuilder-card.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBetsBetbuilderCardComponent {
    betslip = input.required<MyBetsBetSlip>();
    myBetsListContext = input.required<MyBetsListContext>();
    isEpcotEnabled = this.epcotConfig.isEnabled;
    bet = computed(() => this.betslip().bets[0]);
    legsInfo = computed(() => this.bet().betBuilderInfo!.legs);

    constructor(
        public sitecoreMyBets: SitecoreMyBetsConfig,
        public mybetsConfig: MyBetsConfig,
        public myBetsUtilService: MyBetsUtilService,
        private redirectService: RedirectHelperService,
        private tracker: TrackingService,
        private epcotConfig: EpcotConfig,
    ) {}

    eventClick(): void {
        const event = this.bet().event;
        if (event) {
            this.redirectService.goToEvent(event, MarketUrlParam.MyBets);

            this.tracker.track(trackingConstants.EVENT_PAGE_VIEW, {
                [trackingConstants.PAGE_NAME]: 'Event' + (this.myBetsListContext().isEventView ? '_EventView' : '_myBets'),
                [trackingConstants.PAGE_SITE_SECTION]: this.myBetsListContext().isEventView ? 'eventView' : 'myBets',
                eventId: event.id,
            });
        }
    }
}
